export default __webpack_public_path__ + "static/media/gopher.e732e5b9.webp";